import { render, staticRenderFns } from "./OfferEditor.vue?vue&type=template&id=0bbbb345&scoped=true&"
import script from "./OfferEditor.vue?vue&type=script&lang=js&"
export * from "./OfferEditor.vue?vue&type=script&lang=js&"
import style0 from "./OfferEditor.vue?vue&type=style&index=0&id=0bbbb345&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbbb345",
  null
  
)

export default component.exports